import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import backgroundImage from '../assets/Images/mobile/bkgd photo.jpg';
import * as actionTypes from '../constantes/actionTypes';
import { StepView } from '../type';

const MicrositeIntro = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const selectExperience = (isShadematch: boolean) => {
		dispatch({ type: actionTypes.SET_SHADEMATCH, value: isShadematch });
		dispatch({
			type: actionTypes.SWITCH_STEP,
			value: isShadematch ? StepView.shadematchPrivacy : StepView.onBoard,
		});
	};

	return (
		<Container initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
			<Background src={backgroundImage} alt='' />
			<Content>
				<Title>{t('diagnostic-tool-title')}</Title>
				<Buttons>
					<ChoiceButton whileTap={{ scale: 0.98 }} onClick={() => selectExperience(true)}>
						{t('microsite-intro-shadematch')}
					</ChoiceButton>
					<ChoiceButton whileTap={{ scale: 0.98 }} onClick={() => selectExperience(false)}>
						{t('analyze-your-skin')}
					</ChoiceButton>
				</Buttons>
			</Content>
		</Container>
	);
};

const Container = styled(motion.main)`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	min-height: 100vh;
	min-height: 100svh;
	overflow: hidden;
	background: #f4f4f4;
`;

const Background = styled.img`
	position: absolute;
	top: -164px;
	left: 0;
	width: 100%;
	height: auto;
	opacity: 1;
	z-index: 0;
`;

const Content = styled.div`
	position: relative;
	z-index: 1;
	box-sizing: border-box;
	display: flex;
	min-height: 100vh;
	min-height: 100svh;
	flex-direction: column;
	justify-content: flex-end;
	padding: 0 20px 74px;
`;

const Title = styled.h1`
	max-width: 680px;
	margin: 0 0 20px;
	font: normal 300 clamp(32px, 7.8vw, 54px) / 0.98 'Clinique Helvetica Neue';
	letter-spacing: -0.035em;
	color: #0b0b0b;
`;

const Buttons = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px;
`;

const ChoiceButton = styled(motion.button)`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 52px;
	padding: 12px;
	border: 0;
	background: #fff;
	color: #1a1a1a;
	font: normal 400 16px/1.1 'Clinique Helvetica Neue';
	cursor: pointer;

	@media (max-width: 420px) {
		font-size: 14px;
	}
`;

export default MicrositeIntro;
